import { OverflowTooltipLabel } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { CopyProjectToastShell } from './CopyProjectToastShell';
import { useCopyProjectName } from './copy-project-registry';

interface CopyProjectInProgressToastContentProps {
    projectID: string;
}

export function CopyProjectInProgressToastContent({
    projectID,
}: CopyProjectInProgressToastContentProps): ReactNode {
    const projectName = useCopyProjectName(projectID);
    return (
        <CopyProjectToastShell iconName="info" title="Project copy in progress">
            {projectName ? (
                <span className="flex align-items-baseline min-w-0 max-w-full">
                    <span className="flex-none white-space-nowrap">
                        Copying &quot;
                    </span>
                    <OverflowTooltipLabel
                        label={projectName}
                        tooltipMy="center bottom"
                        tooltipAt="center top"
                        className="flex-initial min-w-0 overflow-hidden text-overflow-ellipsis white-space-nowrap"
                    />
                    <span className="flex-none white-space-nowrap">
                        &quot; project…
                    </span>
                </span>
            ) : (
                <span>Copying your project…</span>
            )}
            <span>
                {`This may take a few moments. You'll be notified when it's ready.`}
            </span>
        </CopyProjectToastShell>
    );
}
